import { render, staticRenderFns } from "./PurchaseSaleStorage.vue?vue&type=template&id=6e2ef85d&scoped=true&"
import script from "./PurchaseSaleStorage.vue?vue&type=script&lang=js&"
export * from "./PurchaseSaleStorage.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSaleStorage.vue?vue&type=style&index=0&id=6e2ef85d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ef85d",
  null
  
)

component.options.__file = "PurchaseSaleStorage.vue"
export default component.exports